exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".credit-summary{font-size:.875rem;line-height:.975rem;font-weight:500;color:#fd6c00;border:1px solid #fd6c00;border-radius:2px;margin:8px;padding:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/creditsummary/CreditSummary.scss
 ** module id = 1238
 ** module chunks = 0
 **/